// refactor sass to stylejs (no theme usage)
import UiDialog from 'ui-components/ui-dialog/UiDialog';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledMediaGalleryDialog = styled(UiDialog)(
  () => css`
    &.media-gallery-dialog {
      z-index: 1300 !important;
      .MuiPaper-root {
        max-width: 997px !important;
      }
      .close-icon {
        cursor: pointer;
      }
      .image-gallery {
        .image-gallery-image {
          max-height: 420px;
        }
        .image-gallery-thumbnail-image {
          max-height: 100px;
        }
        .fullscreen {
          .video-wrapper {
            video {
              width: 100%;
              height: calc(100vh - 180px);
            }
          }
          .image-gallery-image {
            max-height: calc(100vh - 180px);
          }
          .image-gallery-thumbnail-image {
            max-height: 100px;
          }
        }
        .image-gallery-thumbnails-container {
          margin-top: 25px;
        }
        .image-gallery-thumbnail {
          border: 3px solid white;

          &.active,
          &:hover {
            border-radius: 8px !important;
            border: 3px solid #199da3;
          }

          .image-gallery-thumbnail-inner {
            .icon {
              position: absolute;
              left: calc(50% - 15px);
              top: calc(50% - 15px);
              opacity: 1;
              z-index: 1;
              width: 30px;
              height: 30px;
              background: rgba(0, 0, 0, 0.7);
              border-radius: 50%;
            }
            .image-gallery-thumbnail-image {
              border-radius: 6px !important;
              opacity: 0.7;
              &:hover {
                opacity: 1;
              }
            }
          }
        }
      }
    }

    @media (max-width: 900px) {
      &.media-gallery-dialog {
        .MuiPaper-root {
          width: calc(100% - 32px);
          margin: 16px;
        }
      }
    }
  `
);
